module.exports = __webpack_public_path__ + "s/img/Power_M_4.8a17de32.jpg";